import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RxLet } from '@rx-angular/template/let';
import { RouterLink } from '@angular/router';
import { IconComponent } from '../icons/icon/icon.component';
import { rxState } from '@rx-angular/state';
import { SubPage } from '../models/models';
import { Observable } from 'rxjs';

interface NavigationState {
  next: SubPage;
  prev: SubPage; 
};

@Component({
  selector: 'lib-arrows',
  standalone: true,
  imports: [CommonModule, RxLet, RouterLink, IconComponent],
  templateUrl: './arrows.component.html',
  styleUrl: './arrows.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ArrowsComponent {
  
  private state = rxState<NavigationState>();

  readonly navigation$ = this.state.select();

  @Input()
  set navigation(navigation$: Observable<NavigationState>) {
    this.state.connect(navigation$);
  }
}
